/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1DomainsVerifyDomainRequestBody = {
  /**
   * Identifies a domain by its name or by its ID. Send the fully qualified domain name, such as
   *
   * @remarks
   * 'api.acme.com', without a scheme, port, or path, or send the domain ID that
   * domains.createDomain returns. You can send an internationalized name in Unicode or in
   * Punycode form. Both forms address the same domain.
   */
  domain: string;
};

/** @internal */
export type V1DomainsVerifyDomainRequestBody$Outbound = {
  domain: string;
};

/** @internal */
export const V1DomainsVerifyDomainRequestBody$outboundSchema: z.ZodType<
  V1DomainsVerifyDomainRequestBody$Outbound,
  z.ZodTypeDef,
  V1DomainsVerifyDomainRequestBody
> = z.object({
  domain: z.string(),
});

export function v1DomainsVerifyDomainRequestBodyToJSON(
  v1DomainsVerifyDomainRequestBody: V1DomainsVerifyDomainRequestBody,
): string {
  return JSON.stringify(
    V1DomainsVerifyDomainRequestBody$outboundSchema.parse(
      v1DomainsVerifyDomainRequestBody,
    ),
  );
}
